import { Link } from "@tanstack/react-router";
import { RZDLogo } from "@synthesis/shared-ui";

import { AppHeaderUserBlock, NavMenu } from "./nav-menu";

export const AppHeader = () => (
  <header className="bg-neutrals-99 fixed left-0 right-0 top-0 z-10 w-full">
    <div className="relative flex h-[var(--app-header-height)] items-center justify-between gap-6 px-8 py-2">
      <div className="flex min-w-0 items-center gap-4">
        <Link to="/" aria-label="На главную" className="shrink-0">
          <RZDLogo className="w-[4.25rem]" />
        </Link>
        <div className="bg-neutrals-90 h-[30px] w-px shrink-0" aria-hidden />
        <div className="flex min-w-0 flex-col justify-between gap-0.5">
          <p className="text-brand-30 truncate text-[13px] font-bold leading-[1.2]">Портал получения технических условий</p>
          <p className="subtitle-xs text-type-minor truncate leading-[1.2]">ОАО «Российские железные дороги»</p>
        </div>
      </div>

      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        <NavMenu />
      </div>

      <AppHeaderUserBlock />
    </div>
  </header>
);
